import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class SaveLeadHitUserService extends UseCase {
  constructor({config, repository, fromLeadHitUserVOToLeadHitUserRequestMapper}) {
    super()
    this._config = config
    this._httpUserRepository = repository
    this._fromLeadHitUserVOToLeadHitUserRequestMapper = fromLeadHitUserVOToLeadHitUserRequestMapper
  }
  /**
   * @method
   * @return {Promise}
   */

  @inlineError
  async execute(leadHitVO) {
    const leadHitUserRequest = this._fromLeadHitUserVOToLeadHitUserRequestMapper.map(leadHitVO)

    const [error, leadHit] = await this._httpUserRepository.saveLeadHit(leadHitUserRequest)

    if (error) return Promise.reject(error)
    return leadHit
  }
}
